import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, Teleport as _Teleport } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "vehicle-info-container-wrapper__info-intro d-flex flex-column-reverse flex-sm-column-reverse flex-lg-row flex-grow-1" }
const _hoisted_3 = { class: "vehicle-info-container-wrapper__info-intro__h2 flex-grow-1" }
const _hoisted_4 = { class: "vehicle-info-container-wrapper__info-intro__img position-relative" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "font-medium vehicle-card__header__data font-medium position-absolute top-0 end-0" }
const _hoisted_7 = { class: "vehicle-info-container-wrapper__content d-flex" }
const _hoisted_8 = { class: "vehicle-info-container-wrapper__content__info-details d-flex flex-column flex-sm-column flex-lg-row" }
const _hoisted_9 = { class: "vehicle-info-container-wrapper__content__info-details__container-1" }
const _hoisted_10 = { class: "vehicle-info-container-wrapper__content__info-details__container-1__item d-flex justify-content-between" }
const _hoisted_11 = { class: "font-weight-400 font-big-400" }
const _hoisted_12 = { class: "font-big" }
const _hoisted_13 = { class: "vehicle-info-container-wrapper__content__info-details__container-1__item d-flex justify-content-between" }
const _hoisted_14 = { class: "font-weight-400 font-big-400" }
const _hoisted_15 = { class: "font-big" }
const _hoisted_16 = { class: "vehicle-info-container-wrapper__content__info-details__container-1__item d-flex justify-content-between" }
const _hoisted_17 = { class: "font-weight-400 font-big-400" }
const _hoisted_18 = { class: "font-big" }
const _hoisted_19 = { class: "vehicle-info-container-wrapper__content__info-details__container-1__item d-flex justify-content-between" }
const _hoisted_20 = { class: "font-weight-400 font-big-400" }
const _hoisted_21 = { class: "font-big" }
const _hoisted_22 = { class: "vehicle-info-container-wrapper__content__info-details__container-2" }
const _hoisted_23 = { class: "vehicle-info-container-wrapper__info-photo parent-photo-container" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["id", "src"]
const _hoisted_26 = { class: "modal-body image-modal-body" }
const _hoisted_27 = ["id", "src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_VehicleCardFreeItemWrapperComponent = _resolveComponent("VehicleCardFreeItemWrapperComponent")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock("div", {
    id: 'vehicle-info-container-wrapper-' + _ctx.vehicle.id,
    class: "vehicle-info-container-wrapper d-flex flex-column position-relative"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.vehicle.make) + " " + _toDisplayString(_ctx.vehicle.model), 1),
        (!_ctx.isDriver)
          ? (_openBlock(), _createBlock(_component_ButtonComponent, {
              key: 0,
              type: "button",
              "data-bs-target": "#selectVehicleModal",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              class: "modal-order-button d-flex align-items-center justify-content-center",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSubmit(_ctx.routesConst.ORDER)))
            }, {
              btnContent: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t('order.order')), 1)
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_ButtonComponent, {
              key: 1,
              type: "button",
              "data-bs-target": "#selectVehicleModal",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              class: "modal-order-button d-flex align-items-center justify-content-center",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSubmit(_ctx.routesConst.CHOOSE_CUSTOM_ROUTE)))
            }, {
              btnContent: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t('order.order')), 1)
              ]),
              _: 1
            }))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("img", {
          class: "w-100",
          src: _ctx.vehicle.vehicle_main_image === null ? '' : _ctx.vehicle.vehicle_main_image.path,
          alt: "vehicle-image"
        }, null, 8, _hoisted_5),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.vehicle.seats) + " " + _toDisplayString(_ctx.$t(_ctx.$helpers.wordEnding(_ctx.vehicle.seats))), 1)
      ])
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "hr-h-margin-top" }, null, -1)),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('maker')), 1),
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.vehicle.make), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('model')), 1),
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.vehicle.model), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('price')), 1),
            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.vehicle.price), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('seating_seats')), 1),
            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.vehicle.seats), 1)
          ])
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "hr-v" }, null, -1)),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_VehicleCardFreeItemWrapperComponent, { "show-item-text": true })
        ])
      ])
    ]),
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "hr-h" }, null, -1)),
    _createElementVNode("div", _hoisted_23, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vehicle.vehicle_additional_images, (image) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: image.id
        }, [
          _createElementVNode("div", {
            class: "car-image-container",
            onClick: ($event: any) => (_ctx.$helpers.openModal($event, {id: 'image-vehicle-' + image.id}, 'custom-modal-backdrop-1'))
          }, [
            _createElementVNode("img", {
              id: 'image-'+image.id.toString(),
              src: image.path,
              alt: "car-1"
            }, null, 8, _hoisted_25),
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "middle" }, null, -1))
          ], 8, _hoisted_24),
          (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
            _createVNode(_component_ModalComponent, {
              "is-main-modal": false,
              "z-index-custom": 'z-index-custom-1',
              id: 'image-vehicle-'+image.id.toString(),
              backdrop: 'custom-modal-backdrop-1',
              "body-overflow": 'body-overflow-1'
            }, {
              "body-content": _withCtx(() => [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("h1", null, [
                    _createElementVNode("img", {
                      id: 'image-'+image.id.toString(),
                      src: image.path,
                      alt: "car"
                    }, null, 8, _hoisted_27)
                  ])
                ])
              ]),
              _: 2
            }, 1032, ["id"])
          ]))
        ], 64))
      }), 128))
    ])
  ], 8, _hoisted_1))
}